export type DateTypes = string | number | Date;
export type DateLike = DateTypes | null;

// 1. safari 不支持 2020-09-29
// 2. json 格式 (ISO) 中包含 “-” —— 2020-09-29T02:03:46.211Z
const smartDate = (value: DateTypes) => ((typeof value === 'string' && !value.includes('Z')) ? value.replace(/-/g, '/') : value);

export class SlugDate extends Date {
  public constructor(value?: DateLike) {
    super(smartDate(value ?? now()));
  }
}

export const now = (): number => new Date().valueOf();
